import { Chain } from '@ankr.com/chains-list';

import { useChainSelectors } from 'modules/chains/components/ChainSelectorsProvider';

import { getChainDocsLink } from '../utils/getChainDocsLink';

export const useChainDocsLink = (chain: Chain) => {
  const { consensus, isConsensusEnabled } = useChainSelectors();

  return getChainDocsLink(chain.id, isConsensusEnabled, consensus);
};
